<template>
  <div class="app-container" id="questionList">
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="110px"
      >
        <el-form-item prop="line">
          <el-select
            ref="line"
            v-model="listQuery.line"
            placeholder="全部"
            clearable
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 250px"
            class="filter-item"
            @change="getList"
          >
            <el-option
              v-for="item in lineList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-radio-group
          @change="getList()"
          v-model="listQuery.more"
          style="vertical-align: top; padding-top: 5px"
        >
          <el-radio
            class="myRadio"
            border
            size="small"
            v-for="(item, index) in configList"
            v-show="index <= 4"
            :key="item.configname"
            :label="item.configname"
            @click.native.prevent="clickRadio(item.configname)"
            >{{ item.condition }}</el-radio
          >
          <!-- <el-radio label="0">所有</el-radio>
          <el-radio label="1">指派给我</el-radio>
          <el-radio label="2">由我创建</el-radio>
          <el-radio label="3">已解决</el-radio>
          <el-radio label="4">待验证</el-radio>-->
        </el-radio-group>

        <el-form-item prop="more" style="margin-left: 15px">
          <el-select
            ref="more"
            v-model="listQuery.more"
            placeholder="更多"
            clearable
            filterable
            size="small"
            style="width: 100px"
            class="filter-item"
            @change="getList"
          >
            <el-option
              v-for="(item, index) in configList"
              v-show="index > 4"
              :key="item.condition"
              :label="item.condition"
              :value="item.configname"
            />
          </el-select>
        </el-form-item>

        <el-button
          size="small"
          style="margin-left: 15px; margin-top: 5px"
          @click="navConfig()"
          >个人导航配置</el-button
        >
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            style="margin-left: 15px"
            icon="el-icon-search"
            size="small"
            :class="show ? 'gray' : ''"
            @click="changeShow()"
            >搜索</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            style="margin-left: 15px"
            @click="addDialog = true"
            >创建</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="110px"
        v-if="show"
        class="hiddenForm"
      >
        <el-form-item label="部门：" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="所属部门"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目：" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmzt + '-' + item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="区域总监:" prop="qyzj">
          <el-select
            ref="qyzj"
            v-model="listQuery.qyzj"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in areaDirectorList"
              :key="item.xm"
              :label="item.xm"
              :value="item.ygbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="问题分类：">
          <el-select
            v-model="sort"
            placeholder="全部产品"
            clearable
            multiple
            collapse-tags
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in sortList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="状态：" prop="status">
          <el-select
            ref="status"
            v-model="listQuery.status"
            placeholder="全部"
            clearable
            multiple
            collapse-tags
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in statusList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="解决方案：" prop="solvePlan">
          <el-select
            ref="solvePlan"
            v-model="listQuery.solvePlan"
            placeholder="全部"
            clearable
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in solvePlan"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="关键词：" prop="title">
          <el-input
            v-model="listQuery.title"
            placeholder="请输入关键词"
            clearable
            size="small"
            style="width: 150px"
          />
        </el-form-item>

        <el-form-item label="员工类型：" prop="linkType">
          <el-select
            ref="linkType"
            v-model="listQuery.linkType"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
            @change="changeShow2()"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="员工选择：" prop="ygbh" v-if="show2">
          <treeselect
            v-model="listQuery.ygbh"
            :multiple="true"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 270px; line-height: 18px; margin-top: 4px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>

        <el-form-item label="问题ID：" prop="id">
          <el-input
            v-model="listQuery.id"
            placeholder="请输入问题ID"
            clearable
            size="small"
            style="width: 150px"
          />
        </el-form-item>

        <el-form-item label="创建时间：" prop="createTime">
          <el-date-picker
            v-model="time"
            type="daterange"
            size="small"
            style="width: 300px"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleChangeTime"
            @keyup.enter.native="getList"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="解决时间：" prop="solveTime">
          <el-date-picker
            v-model="time2"
            type="daterange"
            size="small"
            style="width: 300px"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleChangeTime2"
            @keyup.enter.native="getList"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上线时间：" prop="sxsj">
          <el-date-picker
            v-model="time3"
            type="daterange"
            size="small"
            style="width: 300px"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleChangeTime3"
            @keyup.enter.native="getList"
          ></el-date-picker>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            style="margin-left: 15px"
            @click="getList()"
            >查询</el-button
          >
          <el-button
            icon="el-icon-refresh"
            size="small"
            class="filter-item"
            style="margin-left: 15px"
            @click="reset"
            >重置</el-button
          >
        </span>
      </el-form>
    </div>
    <div class>
      <el-table
        :height="height"
        v-loading="listLoading"
        :data="question.questionList.list.item"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          fixed
          label="操作"
          min-width="150"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <el-button type="primary" size="small">
                操作列
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="handleView(scope.row)">
                    <el-button type="text" size="small">查看</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.control.isdelete == 1">
                  <div>
                    <template>
                      <el-popconfirm
                        title="确定删除吗？"
                        @confirm="handelDel(scope.row)"
                      >
                        <el-button type="text" size="small" slot="reference"
                          >删除</el-button
                        >
                      </el-popconfirm>
                    </template>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.control.isconfirm == 1">
                  <div @click="handleConfirm(scope.row)">
                    <el-button type="text" size="small">确认</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.control.issolve == 1">
                  <div @click="handleSolve(scope.row)">
                    <el-button type="text" size="small">解决</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.control.isverifie == 1">
                  <div @click="handleCheck(scope.row)">
                    <el-button type="text" size="small">验证</el-button>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.control.isclose == 1">
                  <div @click="handleClose(scope.row)">
                    <el-button type="text" size="small">关闭</el-button>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.control.isedit == 1">
                  <div @click="handleEdit(scope.row)">
                    <el-button type="text" size="small">编辑</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="scope.row.control.isinitiatereview == 1"
                >
                  <div>
                    <el-button
                      @click="startReview(scope.row)"
                      type="text"
                      size="small"
                      >发起评审</el-button
                    >
                  </div>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.control.isreview == 1">
                  <div>
                    <el-button
                      @click="review(scope.row)"
                      type="text"
                      size="small"
                      >评审</el-button
                    >
                  </div>
                </el-dropdown-item>
                <!-- <el-dropdown-item
                  v-if="scope.row.control.isinitiatecollaboration == 1"
                >-->
                <!-- <el-dropdown-item
                  v-if="scope.row.control.isinitiatecollaboration == 1"
                >
                  <div @click="handleFqxz(scope.row)">
                    <el-button type="text" size="small">发起协作</el-button>
                  </div>
                </el-dropdown-item> -->

                <el-dropdown-item
                  v-if="scope.row.control.isonlineconfirmation == 1"
                >
                  <div @click="handleOnline(scope.row)">
                    <el-button type="text" size="small">上线确认</el-button>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column
          label="ID"
          align="left"
          prop="id"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="标题"
          prop="title"
          min-width="220px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleView(scope.row)">
              <span>{{ scope.row.title }}</span>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          label="所属条线"
          align="left"
          prop="lineName"
          min-width="180px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="所属部门"
          align="left"
          prop="bmmc"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="所属项目"
          align="left"
          prop="xmmc"
          min-width="180px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="状态"
          align="left"
          prop="statusName"
          min-width="110px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :class="
                scope.row.statusName == '已验证'
                  ? 'green'
                  : scope.row.statusName == '激活'
                  ? 'purple'
                  : scope.row.statusName == '已关闭'
                  ? 'grey'
                  : scope.row.statusName == '已确认'
                  ? 'blue'
                  : scope.row.statusName == '重新激活'
                  ? 'purple'
                  : scope.row.statusName == '重新打开'
                  ? 'red'
                  : scope.row.statusName == '已解决'
                  ? 'yellow'
                  : scope.row.statusName == '已延期'
                  ? 'red'
                  : scope.row.statusName == '协作中'
                  ? 'blue'
                  : scope.row.statusName == '评审中'
                  ? 'blue'
                  : scope.row.statusName == '评审完成'
                  ? 'green'
                  : scope.row.statusName == '评审不通过'
                  ? 'red'
                  : 'grey'
              "
              >{{ scope.row.statusName }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="问题分类"
          align="left"
          prop="sortName"
          min-width="170px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="处理结果"
          align="left"
          prop="solvePlan"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="创建者"
          align="left"
          prop="creator"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="解决者"
          align="left"
          prop="solver"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="解决时间"
          align="left"
          prop="solveTime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="验证者"
          align="left"
          prop="verifier"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="验证时间"
          align="left"
          prop="checkingTime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="指派给"
          align="left"
          prop="designee"
          min-width="80px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status != 5">{{ scope.row.designee }}</div>
            <div v-else>Close</div>
          </template>
        </el-table-column>
        <el-table-column
          label="期望完成时间"
          align="left"
          prop="finishTimeString"
          min-width="120px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="创建时间"
          align="left"
          prop="createTimeString"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="上线时间"
          align="left"
          prop="sxsj"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="question.questionList.list.count > 0"
        :total="question.questionList.list.count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList()"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新增问题"
      :visible.sync="addDialog"
      width="90%"
      v-if="addDialog"
      id="mx-dialog"
      :lock-scroll="false"
      ref="addDialog"
    >
      <Add ref="add" @giveFather="getSon"></Add>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addQuestion()">保存并指派</el-button>
        <el-button @click="addDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 编辑`"
      :visible.sync="editDialog"
      width="90%"
      v-if="editDialog"
      id="mx-dialog"
    >
      <Edit ref="edit" @giveFather="getSon" :mxParams="mxParams"></Edit>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editQuestion()">保存</el-button>
        <el-button type="primary" @click="cxfqps()" v-if="mxParams.status == 10"
          >重新发起评审</el-button
        >
        <el-button @click="editDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 确认`"
      :visible.sync="confirmDialog"
      width="90%"
      v-if="confirmDialog"
      id="mx-dialog"
    >
      <Confirm
        ref="confirm"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></Confirm>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmQuestion()"
          >保存并指派</el-button
        >
        <el-button @click="confirmDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 查看`"
      :visible.sync="viewDialog"
      width="90%"
      v-if="viewDialog"
      id="mx-dialog"
    >
      <ViewQuestion
        ref="view"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></ViewQuestion>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 验证`"
      :visible.sync="checkDialog"
      width="90%"
      v-if="checkDialog"
      id="mx-dialog"
    >
      <Check ref="check" @giveFather="getSon" :mxParams="mxParams"></Check>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkQuestion()" type="primary">保存</el-button>
        <el-button @click="checkDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title} > 关闭`"
      :visible.sync="closeDialog"
      width="90%"
      v-if="closeDialog"
      id="mx-dialog"
    >
      <Close ref="close" @giveFather="getSon" :mxParams="mxParams"></Close>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeQuestion()" type="primary">保存</el-button>
        <el-button @click="closeDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 解决`"
      :visible.sync="solveDialog"
      width="90%"
      v-if="solveDialog"
      id="mx-dialog"
    >
      <Solve ref="solve" @giveFather="getSon" :mxParams="mxParams"></Solve>
      <div slot="footer" class="dialog-footer">
        <el-button @click="solveQuestion()" type="primary">保存</el-button>
        <el-button @click="solveDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 发起协作`"
      :visible.sync="fqxzDialog"
      width="90%"
      v-if="fqxzDialog"
      id="mx-dialog"
    >
      <FqxzQuestion
        ref="fqxz"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></FqxzQuestion>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fqxzQuestion()" type="primary">保存</el-button>
        <el-button @click="fqxzDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="个人导航配置"
      :visible.sync="navConfigDialog"
      width="90%"
      top="20px"
      v-if="navConfigDialog"
      @close="initUserConfig"
    >
      <navConfig v-if="navConfigDialog"></navConfig>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 发起评审`"
      :visible.sync="startReviewDialog"
      width="90%"
      top="20px"
      v-if="startReviewDialog"
    >
      <startReview
        v-if="startReviewDialog"
        :mxParams="mxParams"
        @hideDialog="closeStartReviewDialog"
        @getList="getList"
      ></startReview>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 评审`"
      :visible.sync="reviewDialog"
      width="90%"
      top="20px"
      v-if="reviewDialog"
    >
      <updateReview
        v-if="reviewDialog"
        :mxParams="mxParams"
        @hideDialog="closeReviewDialog"
        @getList="getList"
      ></updateReview>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 上线确认`"
      :visible.sync="onlineDialog"
      width="90%"
      top="20px"
      v-if="onlineDialog"
    >
      <Online ref="online" @giveFather="getSon" :mxParams="mxParams"></Online>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sxqrQuestion()" type="primary">保存</el-button>
        <el-button @click="onlineDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBmxxList, getXmxxList } from "@/api/itWeekly";
import {
  deleteQuestion,
  getDictData,
  getUserConfig,
  questionExport,
} from "@/api/question.js";
import { getAreaDirectorList } from "@/api/xmReview.js";
import Pagination from "@/components/Pagination";
import { formatMomentDate } from "@/utils/utils";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import navConfig from "../question/navConfig";
import startReview from "../question/startReview";
import updateReview from "../question/updateReview";
import Add from "./add.vue";
import Check from "./check.vue";
import Close from "./closeQueastion.vue";
import Confirm from "./confirm.vue";
import Edit from "./edit.vue";
import FqxzQuestion from "./fqxzQuestion.vue";
import Online from "./online.vue";
import Solve from "./solveQueastion.vue";
import ViewQuestion from "./view.vue";

export default {
  // 列表分页
  components: {
    Pagination,
    navConfig,
    startReview,
    updateReview,
    Treeselect,
    Add,
    Edit,
    ViewQuestion,
    Confirm,
    Check,
    Close,
    Solve,
    FqxzQuestion,
    Online,
  },

  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      type: "0",
      height: 100,
      listQuery: {
        id: "",
        line: "",
        more: "",
        bmbh: "",
        xmbh: "",
        sort: "",
        qyzj: "",
        status: [],
        solvePlan: [],
        linkType: "",
        ygbh: [],
        title: "",
        page: 1,
        pageSize: 50,
      },
      line: "",
      show: false,
      show2: false,
      total: 0,
      value: "",
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "0",
        //htzt: "1,2,3,4,5", //合同状态，多个,隔开，如1,3
      },
      time: [],
      time2: [],
      time3: [],
      list: [],
      statusList: [],
      bmList: [],
      xmList: [],
      lineList: [],
      sortList: [],
      configList: [],
      areaDirectorList: [],
      navConfigDialog: false,
      startReviewDialog: false,
      reviewDialog: false,
      dialogFlag1: false,
      dialogFlag2: false,
      sort: [],
      options: [
        {
          value: "1",
          label: "问题创建者",
        },
        {
          value: "2",
          label: "问题确认者",
        },
        {
          value: "3",
          label: "问题解决者",
        },
        {
          value: "4",
          label: "问题验证者",
        },
        {
          value: "5",
          label: "问题关闭者",
        },
        {
          value: "6",
          label: "问题被指派者",
        },
      ],
      solvePlan: [
        {
          value: "1",
          label: "设计如此",
        },
        {
          value: "2",
          label: "不解决",
        },
        {
          value: "3",
          label: "外部原因",
        },
        {
          value: "4",
          label: "已解决",
        },
        {
          value: "5",
          label: "无法重现",
        },
        {
          value: "6",
          label: "延期处理",
        },
      ],
      more: [
        {
          value: "0",
          label: "所有",
        },
        { value: "5", label: "由我确认" },
        {
          value: "6",
          label: "由我验证",
        },
        {
          value: "7",
          label: "待确认",
        },
        {
          value: "8",
          label: "待关闭",
        },
        {
          value: "9",
          label: "已延期",
        },
        {
          value: "10",
          label: "由我解决",
        },
        {
          value: "11",
          label: "由我评审",
        },
      ],
      addDialog: false,
      editDialog: false,
      viewDialog: false,
      confirmDialog: false,
      checkDialog: false,
      closeDialog: false,
      solveDialog: false,
      fqxzDialog: false,
      onlineDialog: false,
      mxParams: {},
      listLoading: true,
    };
  },
  computed: {
    ...mapGetters(["deptUser", "user", "question"]),
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }

    this.$store.dispatch("common/fetchUserInfoAction");
    getDictData("pmp_quality_status", 1).then((res) => {
      if (res.code === 0) {
        this.statusList = res.data;
      }
    });

    getDictData("pmp_quality_line", 1).then((res) => {
      if (res.code === 0) {
        this.lineList = res.data;
      }
    });
    getDictData("pmp_quality_sort", 1).then((res) => {
      if (res.code === 0) {
        this.sortList = res.data;
      }
    });

    getBmxxList(this.data2.type, this.data2.range).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    this.getAreaDirectorList({ bmbh: "" });

    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      this.listQuery.bmbh,
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    this.initUserConfig();
  },
  // mounted() {
  //   var a = 1;
  //   this.configList.forEach((item) => {
  //     if (item.configname == "wjj") {
  //       this.clickRadio(item.configname);
  //       a = 2;
  //     }
  //   });
  //   if (a == 1) {
  //     this.getList();
  //   }
  // },
  methods: {
    getAreaDirectorList(bmbh) {
      getAreaDirectorList(bmbh).then((res) => {
        if (res.code == 0) {
          this.areaDirectorList = res.data;
        }
      });
    },

    navConfig() {
      this.navConfigDialog = true;
    },
    initUserConfig() {
      getUserConfig().then((res2) => {
        if (res2.code == 0) {
          this.listQuery.more = "wjj";
          this.configList = [];
          res2.data.map((t, i) => {
            i === 0 ? null : this.configList.push(t);
          });
          console.log(res2);
          this.listQuery.line =
            res2.data[0].condition === ""
              ? []
              : res2.data[0].condition.split(",");
          this.line =
            res2.data[0].condition === ""
              ? []
              : res2.data[0].condition.split(",");
        }
        var a = 1;
        this.configList.forEach((item) => {
          if (item.configname == "wjj") {
            a = 2;
          }
        });
        if (a == 1) {
          this.listQuery.more = "";
        }
        this.getList();
      });
    },
    startReview(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
      };
      this.startReviewDialog = true;
    },
    closeStartReviewDialog() {
      this.startReviewDialog = false;
    },
    review(row) {
      this.mxParams = {
        id: row.id,
        reviewId: row.reviewId,
        title: row.title,
      };
      this.reviewDialog = true;
    },
    closeReviewDialog() {
      this.reviewDialog = false;
    },
    changeShow() {
      this.show = !this.show;
      this.getTableHeight();
    },
    changeShow2() {
      if (this.listQuery.linkType) {
        this.show2 = true;
      } else {
        this.show2 = false;
      }
      this.getTableHeight();
    },
    getTableHeight() {
      this.$nextTick(() => {
        const docH = document.documentElement.clientHeight;
        const mycontainerH =
          document.querySelector(".mycontainer").clientHeight;
        const hiddenFormH = document.querySelector(".hiddenForm")
          ? document.querySelector(".hiddenForm").clientHeight
          : 0;
        this.height = docH - mycontainerH - hiddenFormH - 100;
      });
    },
    getList(type) {
      this.listLoading = true;
      let sort1 = "";
      this.sort.forEach((item) => {
        sort1 = sort1 + item + ",";
      });
      sort1 = sort1.substring(0, sort1.length - 1);
      this.listQuery.sort = sort1;
      // let ygbh = null;
      // ygbh = this.listQuery.ygbh;
      let line = null;
      line = this.listQuery.line ? this.listQuery.line.join(",") : null;
      // if (type) {
      //   this.listQuery.more = type;
      // }

      const solvePlan = this.listQuery.solvePlan
        ? this.listQuery.solvePlan.join(",")
        : "";
      const status = this.listQuery.status
        ? this.listQuery.status.join(",")
        : "";
      const ygbh = this.listQuery.ygbh ? this.listQuery.ygbh.join(",") : "";
      const params = { ...this.listQuery, ygbh, line, solvePlan, status };
      this.$store
        .dispatch("question/fetchQuestionListAction", params)
        .then((res) => {
          if (res.code == 0) {
            this.listLoading = false;
            this.mxParams.status = null;
            this.getTableHeight();
          }
        });
    },
    // 重置
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{
          id: null,
          line: this.line,
          bmbh: null,
          xmbh: null,
          sort: "",
          status: [],
          solvePlan: [],
          linkType: null,
          ygbh: [],
          title: null,
          qsrq: null,
          jsrq: null,
          startSolveTime: null,
          endSolveTime: null,
          sxqsrq: null,
          sxjsrq: null,
        },
      };
      this.time = [];
      this.time2 = [];
      this.sort = [];
      this.time3 = [];
    },

    handleChangeBm(i) {
      this.listQuery.bmbh = i;
      getXmxxList(
        this.data2.htlx,
        this.data2.range,
        this.data2.htzt,
        i,
        "1,2,3"
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleChangeTime(value) {
      if (!value) {
        this.listQuery.qsrq = "";
        this.listQuery.jsrq = "";
        return;
      }
      this.listQuery.qsrq = formatMomentDate(value[0]);
      this.listQuery.jsrq = formatMomentDate(value[1]);
    },
    handleChangeTime2(value) {
      if (!value) {
        this.listQuery.startSolveTime = "";
        this.listQuery.endSolveTime = "";
        return;
      }
      this.listQuery.startSolveTime = formatMomentDate(value[0]);
      this.listQuery.endSolveTime = formatMomentDate(value[1]);
    },
    handleChangeTime3(value) {
      if (!value) {
        this.listQuery.sxqsrq = "";
        this.listQuery.sxjsrq = "";
        return;
      }
      this.listQuery.sxqsrq = formatMomentDate(value[0]);
      this.listQuery.sxjsrq = formatMomentDate(value[1]);
    },

    //导出
    handleExport() {
      // let ygbh = null;
      // ygbh = this.listQuery.ygbh;
      let line = null;
      line = this.listQuery.line ? this.listQuery.line.join(",") : null;
      const solvePlan = this.listQuery.solvePlan.join(",");
      const status = this.listQuery.status.join(",");
      const ygbh = this.listQuery.ygbh.join(",");
      const params = { ...this.listQuery, ygbh, line, solvePlan, status };
      questionExport(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    addQuestion() {
      this.$refs.add.submitUpload();
    },
    editQuestion() {
      this.$refs.edit.submitUpload();
    },
    confirmQuestion() {
      this.$refs.confirm.submitUpload();
    },
    checkQuestion() {
      this.$refs.check.submitUpload();
    },
    closeQuestion() {
      this.$refs.close.saveForm();
    },
    solveQuestion() {
      this.$refs.solve.submitUpload();
    },
    fqxzQuestion() {
      this.$refs.fqxz.saveForm();
    },
    handleEdit(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
        status: row.status,
      };
      this.editDialog = true;
    },
    handleView(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
      };
      this.viewDialog = true;
    },
    handleConfirm(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
      };
      this.confirmDialog = true;
    },
    handleCheck(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
      };
      this.checkDialog = true;
    },
    handleClose(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
      };
      this.closeDialog = true;
    },
    handleSolve(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
      };
      this.solveDialog = true;
    },
    handleFqxz(row) {
      this.mxParams = {
        id: row.id,
        title: row.title,
      };
      this.fqxzDialog = true;
    },
    getSon() {
      this.addDialog = false;
      this.editDialog = false;
      this.viewDialog = false;
      this.confirmDialog = false;
      this.checkDialog = false;
      this.closeDialog = false;
      this.solveDialog = false;
      this.fqxzDialog = false;
      this.onlineDialog = false;
      this.getList();
    },

    handelDel(row) {
      deleteQuestion({ id: row.id }).then((res) => {
        if (res.code == 0) {
          this.getList();
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 编辑--重新发起评审
    cxfqps() {
      this.$refs.edit.submitUpload(true);
    },
    handleOnline(row) {
      this.onlineDialog = true;
      this.mxParams = {
        id: row.id,
        title: row.title,
        xmmc: row.xmmc,
        detail: row.detail,
      };
    },
    sxqrQuestion() {
      this.$refs.online.submitUpload();
    },
    clickRadio(e) {
      if (this.listLoading) return;
      if (this.listQuery.more == e) {
        this.listQuery.more = null;
      } else {
        this.listQuery.more = e;
      }
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: rgb(255, 255, 255);
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.red {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #b9b7b7 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.blue {
  color: #3498db !important;
  border-color: #fff !important;
  background-color: #fff;
}
.green {
  color: #1abc9c !important;
  border-color: #fff !important;
  background-color: #fff;
}
.yellow {
  color: #f4b500 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.purple {
  color: #e744f0 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
/* 多选标签样式优化 */
#questionList ::v-deep .el-tag.el-tag--info {
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
<style scoped>
#questionList .el-form-item {
  margin-bottom: 0px;
}
</style>